import {initElements} from "../define/shared"
import Splide from '@splidejs/splide'

export default function initSlider() {
    initElements(".ph-block.slider", slider => {
        const splide = slider.querySelector('.splide')

        new Splide(splide, {
            arrows: false,
            type: 'loop',
            autoplay: true,
            speed: 1000,
            pagination: true,
            interval: 8000,
            perPage: 1,
            focus: 'center',
            isNavigation: true
        }).mount()
    })
}
